<template>
    <v-card v-if="!loading">
        <v-card-title>Feratel 
            <v-tooltip  v-if="huisFeratel.feratel_connection_check !== '' && huisFeratel.feratel_open_blocks !== ''" color="success" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon left color="success" class="ma-1" v-bind="attrs" v-on="on">
                        mdi-check-circle-outline
                    </v-icon>
                </template>
            <span>Working connection since {{ huisFeratel.feratel_connection_check }}. Open blocks since {{ huisFeratel.feratel_open_blocks }}</span>
            </v-tooltip>
            <v-tooltip v-if="huisFeratel.feratel_open_blocks == '' && huisFeratel.feratel_connection_check !== ''" color="warning" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon left color="warning" class="ma-1" v-bind="attrs" v-on="on">
                        mdi-alert-circle-outline
                    </v-icon>
                </template>
            <span>Connection working, no open block (use button to open)</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn v-if="huisFeratel.feratel_oestat && huisFeratel.feratel_betriebnr && huisFeratel.feratel_activate_connection_allowed && data_saved" class="primary mx-2" x-small @click="openHuisFeratel(); loader = 'loadingferatel'" :loading="loadingferatel">Open blocks</v-btn>
            <v-btn v-if="huisFeratel.feratel_oestat && huisFeratel.feratel_betriebnr && huisFeratel.feratel_activate_connection_allowed && data_saved" class="primary mx-2" x-small @click="checkHuisFeratel(); loader = 'loadingferatel'" :loading="loadingferatel">Check Connection</v-btn>
            <v-dialog  v-if="(huisFeratel.feratel_oestat !== '' || huisFeratel.feratel_betriebnr !== '' || huisFeratel.feratel_connection_check !== '' || huisFeratel.feratel_guestcard !== '' || huisFeratel.feratel_loginname !== '') && huisFeratel.feratel_activate_connection_allowed"
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="primary mx-2" x-small v-bind="attrs" v-on="on" >
          Remove connection
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Are you sure?
        </v-card-title>

        <v-card-text>
          Are you sure you want to remove the Feratel connection?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="removeHuisFeratel()"
          >
            Remove connection
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
            
        </v-card-title>
        <v-divider></v-divider>
        <v-row no-gutters class="px-2 pt-3">
            <v-col class="pr-4" cols="12">
                <v-select v-model="huisFeratel.feratel_proces_status" label="Feratel process status" :items="feratelStatusChoices" item-text="oms" item-value="value"></v-select>
            </v-col>
        </v-row>
        <v-row no-gutters class="px-2">
            <v-col class="pr-4" cols="6">
                <v-text-field v-model="huisFeratel.feratel_oestat" label="Oestat (municipality)"></v-text-field>
            </v-col>
            <v-col class="pr-4" cols="6">
                <v-text-field v-model="huisFeratel.feratel_betriebnr" label="Betriebnr (accommodation)"></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="px-2">
            <v-col class="pr-4" cols="6">
                <v-text-field 
                    v-model="huisFeratel.feratel_loginname" 
                    label="Feratel login name"
                    data-1p-ignore 
                    data-lpignore="true" 
                    data-protonpass-ignore="true"
                    data-bwignore
                    >
                </v-text-field>
            </v-col>
            <v-col class="pr-4" cols="6">
                <v-text-field
                    v-model="huisFeratel.feratel_password"
                    label="Feratel password"
                    :type="showFeratelPassword ? 'text' : 'password'"
                    :append-icon="showFeratelPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showFeratelPassword = !showFeratelPassword"
                    autocomplete="new-password"
                    data-1p-ignore 
                    data-bwignore 
                    data-lpignore="true" 
                    data-protonpass-ignore="true"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row no-gutters class="px-2">
            <v-col class="pr-4" cols="12" md="12">
                <v-text-field 
                    v-model="huisFeratel.feratel_webclient" 
                    label="Feratel webclient link"
                    append-icon="mdi-open-in-new"
                    @click:append="openFeratelWebclientLink"
                ></v-text-field>  
            </v-col>    
            
        </v-row>
        <v-row no-gutters class="px-2">
            <v-col class="pr-4" cols="6">
                <v-select v-model="huisFeratel.feratel_guestcard" label="Guestcard" :items="guest_card_choices2" item-text="oms" item-value="value"></v-select>
            </v-col>
            <v-col class="pr-4" cols="6">
                <v-checkbox v-model="huisFeratel.feratel_hostbooking" label="Feratel Registration for Host Booking"></v-checkbox>
            </v-col>
        </v-row>
        <v-row no-gutters class="px-2 pt-2 pb-4">
            <v-col cols="12">
                <hokl_hosm_links :links="huisFeratel.links" @updateData="updateLinks"></hokl_hosm_links>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary mx-2" small @click="updHuisFeratel">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import hokl_hosm_links from "@/components/huov/ui/hokl_hosm_links.vue";
    export default {
        components: { hokl_hosm_links },
        props: {
            huis_encrid: {
                type: String,
                required: true
            }
        },
        data() { 
            return {
                loading: true,
                loader: null,
                loadingferatel: false,
                huisFeratel: {},
                guest_card_choices: ['Unknown','No Guestcards','Guestcards sent automatic','Guestcards sent manually'],
                guest_card_choices2: [],
                feratelStatusChoices: [],
                dialog: false,
                data_saved: false,
                showFeratelPassword: false
                
            }
        },
        mounted() {
            this.getHuisFeratel();
        },
        watch: {
        loader () {
            const l = this.loader
            this[l] = !this[l]
            },
        },
        methods: {
            updateLinks(data) {
                this.huisFeratel.links = data.value;
            },
            openFeratelWebclientLink() {
                if (!this.huisFeratel.feratel_webclient) {
                    return;
                }

                const enteredUrl = this.huisFeratel.feratel_webclient.trim();
                const hasProtocol = /^https?:\/\//i.test(enteredUrl);
                const urlToOpen = hasProtocol ? enteredUrl : `https://${enteredUrl}`;

                window.open(urlToOpen, '_blank', 'noopener,noreferrer');
            },
            getHuisFeratel() {
                this.$axios.post("ares/json/ares/huis/getHuisFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisFeratel"
                    },
                    getHuisFeratel: {
                        huis_encrid: this.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log('feratel', res.data.getHuisFeratel);
                        this.huisFeratel = res.data.getHuisFeratel;
                        this.guest_card_choices = res.data.getHuisFeratel.guestCardChoices;
                        this.guest_card_choices2 = res.data.getHuisFeratel.guestCardChoices2;
                        this.feratelStatusChoices = res.data.getHuisFeratel.feratelStatusChoices;
                        this.loading = false;
                        if (res.data.getHuisFeratel.feratel_oestat && res.data.getHuisFeratel.feratel_betriebnr){
                            this.data_saved = true;
                        } 
                    }
                });
            },
            updHuisFeratel() { 
                this.$axios.post("ares/json/ares/huis/updHuisFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHuisFeratel"
                    },
                    updHuisFeratel: this.huisFeratel,
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.huisFeratel.feratel_guestcard = res.data.updHuisFeratel.feratel_guestcard;
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHuisFeratel.text,
                            color: res.data.updHuisFeratel.color
                        }); 
                    }
                }).finally(() => {
                    this.data_saved = true;
                });
            },
            checkHuisFeratel() { 
                this.$axios.post("ares/json/ares/huis/checkHuisFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "checkHuisFeratel"
                    },
                    checkHuisFeratel: this.huisFeratel,
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.huisFeratel = res.data.checkHuisFeratel;
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.checkHuisFeratel.text,
                            color: res.data.checkHuisFeratel.color
                        }); 
                    }
                }).finally(() => {
                    this.loadingferatel = false;
                    this.loader = null;
                    this.loading = false;
                });
            },
            openHuisFeratel() { 
                this.$axios.post("ares/json/ares/huis/openHuisFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "openHuisFeratel"
                    },
                    openHuisFeratel: this.huisFeratel,
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.openHuisFeratel.text,
                            color: res.data.openHuisFeratel.color
                        }); 
                    }
                }).finally(() => {
                    this.loadingferatel = false;
                    this.loader = null;
                    this.loading = false;
                });
            },
            removeHuisFeratel() {
                this.$axios.post("ares/json/ares/huis/removeHuisFeratel.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "removeHuisFeratel"
                    },
                    removeHuisFeratel: this.huisFeratel,
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.huisFeratel = res.data.removeHuisFeratel;
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.removeHuisFeratel.text,
                            color: res.data.removeHuisFeratel.color
                        }); 
                    }
                }).finally(() => {
                    this.loadingferatel = false;
                    this.loader = null;
                    this.loading = false;
                    this.dialog = false;
                });
                
            },

        }
    }
</script>
